import Hub from '../events/Hub'

export default {
  methods: {
    clickListItem (itemId, event) {
      this.saveClickLocation(event)
      this.redirectToItemPage(itemId)
      Hub.$emit('click-list-item')
    },
    saveClickLocation (event) {
      console.log(event)
      let scrollPoint = {
        x: event.target.offsetLeft,
        y: event.target.offsetTop
      }

      console.log('setting scroll point to', scrollPoint)
      this.$store.dispatch('setScrollPoint', scrollPoint)
    },
    redirectToItemPage (itemId) {
      this.$router.push('/locations/' + itemId)
    },
    moveToScrollPoint () {
      let scrollPoint = this.$store.getters.getScrollPoint
      console.log('moving to', scrollPoint)

      if (scrollPoint) {
        let htmlElement = document.querySelector('.scrollable') || document.querySelector('html')

        this.$nextTick(() => {
          htmlElement.scrollTop = scrollPoint.y
        })

        this.clearScrollPoint()
      }
    },
    clearScrollPoint () {
      this.$store.dispatch('setScrollPoint', {})
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/scrollPointMixin.js